import React from "react";

import { useViewport } from "@/contexts/ViewportContext";
import { useAppNavigation } from "@/hooks/application/navigation";
import { useClientNotifications, useRemoveNotification } from "@/hooks/domain/clientNotifications";
import { RootNavigation } from "@/navigation/Root";

import NotificationListMobile from "./NotificationList.mobile";
import NotificationListWeb from "./NotificationList.web";

const NotificationList = () => {
  const { isWebMode } = useViewport();
  const { goBack, navigateBetweenStacks } = useAppNavigation<RootNavigation>();

  const { data, isLoading } = useClientNotifications();

  const { mutate } = useRemoveNotification();

  const onSelect = (notificationId: string) => {
    const notification = data?.find((item) => item._id === notificationId);
    navigateBetweenStacks("orderStack", "orderTracking", {
      orderId: notification?.id_pedido,
    });
  };

  const onPressDelete = (notificationId: string) => {
    mutate(notificationId);
  };

  const Screen = isWebMode ? NotificationListWeb : NotificationListMobile;

  return (
    <Screen
      notifications={data}
      isLoading={isLoading}
      onBack={goBack}
      onPressDelete={onPressDelete}
      onSelect={onSelect}
    />
  );
};

export default NotificationList;
